<template>
      <!--====== APPIE PROJECT 3 PART START ======-->
    
    <section class="appie-project-3-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="appie-project-3-box d-block d-md-flex justify-content-between align-items-center wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="400ms">
                        <h4 class="title">Tenant Gem Recruitment <h3>So, do you think you are a gem?</h3><p>Join our curation process and get a chance to show off your culinary gems at the Hunger Gems Festival.</p></h4> 
                        <a class="main-btn" href="#">Yes I Am</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!--====== APPIE PROJECT 3 PART ENDS ======-->
</template>

<script>
export default {

}
</script>

<style>

</style>